import context from "@helpers/context";

const [
    TrackingFormContext,
    useTrackingFormContext
] = context<Admin.Contexts.TrackingForm>()

export default TrackingFormContext
export { useTrackingFormContext }